import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ConversionDialog from 'components/Modals/ConversionDialog';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { locations } from 'services/routes/locations';
import useAnalytics from 'services/hooks/analytics/useAnalytics';
import { events } from 'services/analytics';

interface PropsType {
  isOpen: boolean;
  onClose: () => void;
}

const FreeUserAIGenerationLimitDialog = ({ isOpen, onClose }: PropsType) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { track } = useAnalytics();

  const handleSubmitClick = () => {
    track(
      events.upgradeSubscription(
        'generation_limit_reached_modal',
        AnalyticsEventLocation.AI_MUSIC_GENERATOR
      )
    );

    navigate(locations.subscription.pricing.pathname(''));
    onClose();
  };

  return (
    <ConversionDialog
      title={t('aiMusicGenerator:generationLimit:title')}
      description={t('aiMusicGenerator:generationLimit:descriptionFree')}
      state={{
        isOpen,
        error: null,
        isLoading: false,
      }}
      action={{
        onSubmit: handleSubmitClick,
        onClose,
        onExited: onClose,
      }}
      submitText={t('aiMusicGenerator:generationLimit:upgrade')}
      closeText={t('aiMusicGenerator:generationLimit:goBack')}
    />
  );
};

export default FreeUserAIGenerationLimitDialog;
